import React from 'react';

import LogoProps from './Logo.types';
import useWindowDimensions from '../../utils/useWindowDimensions';
import LogoImage from './LogoImage';

const Logo = (props: LogoProps) => {
  const { responsiveOptions } = props;

  if (!responsiveOptions?.length) {
    return <LogoImage {...props} />;
  }

  const { width } = useWindowDimensions();

  let logoImage = <LogoImage {...props} />;
  responsiveOptions.forEach((ro) => {
    if (width <= ro.breakPoint) {
      logoImage = <LogoImage {...ro} />;
    }
  });

  return logoImage;
};

export default Logo;
